module.exports = __webpack_public_path__ + "media/images/weather/443_day-34029e7dbb382c4fe70df566086fcaae.png";